import {SuperSelect} from "./super-select";
import {CA_stringTrim} from "../../common/strings";

/**
 TimeAmountInput class.  An encapsulation for working with
 an Easyforms TimeAmountInput.
 [public methods]
 setEnabled(enabled): enable or disable all inputs of the TimeAmountInput
 getAmount(): get the amount field as an integer
 getUnitOrd(): get the unit as an integer or null if nothing is seleced.
 */
export class TimeAmountInput {
    constructor(formReference, easyFormsName) {
        this.frm = formReference;
        this.name = easyFormsName;
    }

    exists() {
        return !!this.frm.elements[this.name + "_txtAmount"];
    };

    setEnabled(enabled) {
        //txtAmount
        this.frm.elements[this.name + "_txtAmount"].disabled = !enabled;

        //selUnits
        this.frm.elements[this.name + "_selUnits"].disabled = !enabled;
    };

    getAmount() {
        let numStr = this.frm.elements[this.name + "_txtAmount"].value;
        let num = parseInt(CA_stringTrim(numStr), 10);
        if (!isNaN(num))
            return num;
        else
            return null;
    };

    getUnitOrd() {
        let ss = new SuperSelect(this.frm.elements[this.name + "_selUnits"]);
        let opt = ss.getSelectedOption();
        if (opt != null) {
            let num = parseInt(opt.getValue(), 10);
            if (!isNaN(num))
                return num;
        }
        return null;
    };
}